import { useState, useEffect, useCallback } from 'react'
import { cajaApi } from '../api/caja'
import { fmtFecha, fmtFechaHora, fmtMonto } from '../utils/fecha'
import Boton from '../components/Boton'

const EST = {
  abierta: { bg: '#eff6ff', color: '#1d4ed8', label: 'Abierta' },
  cerrada: { bg: '#fef9c3', color: '#854d0e', label: 'Cerrada' },
  enviada: { bg: '#dcfce7', color: '#166534', label: 'Enviada' },
  error: { bg: '#fee2e2', color: '#991b1b', label: 'Error de envío' },
}

export default function CajaMinutasPage() {
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [fTipo, setFTipo] = useState('')
  const [fEstado, setFEstado] = useState('')
  const [detalle, setDetalle] = useState(null)
  const [busy, setBusy] = useState(null)

  const cargar = useCallback(async () => {
    setLoading(true)
    const params = {}
    if (fTipo) params.tipo = fTipo
    if (fEstado) params.estado = fEstado
    const { data } = await cajaApi.minutas(params)
    setRows(data.data || data)
    setLoading(false)
  }, [fTipo, fEstado])
  useEffect(() => { cargar() }, [cargar])

  const ver = async (id) => {
    const { data } = await cajaApi.minuta(id)
    setDetalle(data)
  }
  const reenviar = async (id) => {
    setBusy(id)
    try { await cajaApi.reenviarMinuta(id); await cargar() } finally { setBusy(null) }
  }

  return (
    <div style={st.wrap}>
      <h1 style={st.h1}>Minutas de caja</h1>
      <div style={st.filtros}>
        <select style={st.input} value={fTipo} onChange={e => setFTipo(e.target.value)}>
          <option value="">Todos los tipos</option>
          <option value="pago">Pagos (haber)</option>
          <option value="cobranza">Cobranzas (debe)</option>
        </select>
        <select style={st.input} value={fEstado} onChange={e => setFEstado(e.target.value)}>
          <option value="">Todos los estados</option>
          {Object.keys(EST).map(k => <option key={k} value={k}>{EST[k].label}</option>)}
        </select>
      </div>
      <div style={st.card}>
        <table style={st.table}>
          <thead><tr>
            <th style={st.th}>Fecha</th><th style={st.th}>Tipo</th><th style={st.th}>Estado</th>
            <th style={{ ...st.th, textAlign: 'right' }}>Movs</th><th style={{ ...st.th, textAlign: 'right' }}>Total</th>
            <th style={st.th}>Enviada</th><th style={st.th}></th>
          </tr></thead>
          <tbody>
            {loading && <tr><td colSpan={7} style={st.empty}>Cargando...</td></tr>}
            {!loading && rows.length === 0 && <tr><td colSpan={7} style={st.empty}>Sin minutas.</td></tr>}
            {rows.map(m => {
              const e = EST[m.estado] || EST.abierta
              return (
                <tr key={m.id} style={st.tr}>
                  <td style={st.td}>{fmtFecha(m.fecha)}</td>
                  <td style={st.td}>{m.tipo === 'cobranza' ? 'Cobranzas' : 'Pagos varios'}</td>
                  <td style={st.td}><span style={{ ...st.badge, background: e.bg, color: e.color }}>{e.label}</span></td>
                  <td style={{ ...st.td, textAlign: 'right' }}>{m.cantidad}</td>
                  <td style={{ ...st.td, textAlign: 'right', fontWeight: 700 }}>$ {fmtMonto(m.total)}</td>
                  <td style={st.td}>{m.enviada_at ? fmtFechaHora(m.enviada_at) : '—'}</td>
                  <td style={{ ...st.td, textAlign: 'right' }}>
                    <Boton variante="secondary" sm onClick={() => ver(m.id)}>Ver</Boton>
                    {m.archivo && <a style={st.btnGhost} href={cajaApi.descargarMinuta(m.id)}>Archivo</a>}
                    {(m.estado === 'error' || m.estado === 'cerrada') && (
                      <Boton variante="send" sm style={{ marginLeft: 6 }} onClick={() => reenviar(m.id)} disabled={busy === m.id}>
                        {busy === m.id ? '...' : 'Reenviar'}
                      </Boton>
                    )}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>

      {detalle && (
        <div style={st.modalBg}>
          <div style={st.modal} onClick={e => e.stopPropagation()}>
            <div style={st.modalHead}>
              <h3 style={{ margin: 0 }}>Minuta #{detalle.id} · {detalle.tipo === 'cobranza' ? 'Cobranzas' : 'Pagos varios'} · {fmtFecha(detalle.fecha)}</h3>
              <Boton variante="ghost" sm onClick={() => setDetalle(null)}>Cerrar</Boton>
            </div>
            {detalle.error_envio && <div style={st.err}>Último error: {detalle.error_envio}</div>}
            <table style={st.table}>
              <thead><tr>
                <th style={st.th}>Cuenta</th>{detalle.tipo === 'cobranza' && <th style={st.th}>Cliente</th>}
                <th style={st.th}>Concepto</th><th style={{ ...st.th, textAlign: 'right' }}>Importe</th>
              </tr></thead>
              <tbody>
                {(detalle.movimientos || []).map(m => (
                  <tr key={m.id} style={st.tr}>
                    <td style={st.td}><code style={st.code}>{m.codigo_cuenta}</code> {m.nombre_cuenta}</td>
                    {detalle.tipo === 'cobranza' && <td style={st.td}>{[m.cliente_codigo, m.cliente_nombre].filter(Boolean).join(' · ') || '—'}</td>}
                    <td style={st.td}>{m.concepto || '—'}</td>
                    <td style={{ ...st.td, textAlign: 'right', fontWeight: 700 }}>$ {fmtMonto(m.importe)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div style={{ textAlign: 'right', marginTop: 10, fontWeight: 800 }}>Total: $ {fmtMonto(detalle.total)}</div>
          </div>
        </div>
      )}
    </div>
  )
}

const st = {
  wrap: { padding: '1.25rem', maxWidth: 1000, margin: '0 auto' },
  h1: { margin: '0 0 12px', fontSize: '1.4rem', color: '#1e293b' },
  filtros: { display: 'flex', gap: 10, marginBottom: 12 },
  card: { background: 'white', border: '1px solid #e2e8f0', borderRadius: 10, padding: 12 },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' },
  th: { textAlign: 'left', padding: '0.5rem 0.6rem', borderBottom: '2px solid #e2e8f0', color: '#475569', fontWeight: 700, fontSize: '0.78rem' },
  tr: { borderBottom: '1px solid #f1f5f9' },
  td: { padding: '0.5rem 0.6rem', color: '#334155' },
  code: { background: '#f1f5f9', padding: '0 4px', borderRadius: 4, fontWeight: 700, fontSize: '0.78rem' },
  badge: { padding: '2px 8px', borderRadius: 20, fontSize: '0.75rem', fontWeight: 700 },
  empty: { padding: '1rem', textAlign: 'center', color: '#94a3b8' },
  input: { padding: '0.45rem 0.6rem', border: '1px solid #cbd5e1', borderRadius: 7, fontSize: '0.875rem' },
  btnGhost: { padding: '0.35rem 0.7rem', background: 'transparent', border: '1px solid #cbd5e1', borderRadius: 7, cursor: 'pointer', fontSize: '0.8rem', color: '#475569', marginLeft: 6, textDecoration: 'none', display: 'inline-block' },
  modalBg: { position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 },
  modal: { background: 'white', borderRadius: 12, padding: 18, width: 720, maxWidth: '100%', maxHeight: '85vh', overflow: 'auto' },
  modalHead: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 },
  err: { marginBottom: 10, padding: '0.5rem 0.7rem', background: '#fee2e2', color: '#991b1b', borderRadius: 7, fontSize: '0.85rem' },
}
